import { msalInstance } from "./index";

export const isAccountingPersonnel = (): boolean => {
    let userEmail = msalInstance.getActiveAccount()?.username ?? "";
    let userID = userEmail.substring(0, userEmail.indexOf("@")).toUpperCase();
    return userID === "TBIRD" || userID === "EWALKER";
}
